<template>
		<el-dialog title="绑定客户名称" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
					<el-row>
						<el-form-item label="通话编号">
								<div>{{form.CallSheetId}}</div>
						</el-form-item>
					</el-row>

					<el-row>
						<el-form-item label="客户名称">
								<el-input v-model="form.companyName" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {SetCompanyName} from "@/api/bd";
import {getToken} from "@/utils/auth";

export default {
		name: "EditAccountDialog",
		components: {},
		props: ['visible', 'currentItem'],
		watch: {
				async visible(newValue) {
						if (newValue) {
								if (this.currentItem?.CallSheetId) {
										this.form = this.currentItem;
								}
						}
				}
		},
		data() {
				return {
						form:{},
				};
		},
		methods: {
				async onConfirm() {
						const {CallSheetId, companyName} = this.form;
						await SetCompanyName({userId: getToken(), CallSheetId, companyName});
						this.beforeClose();
						this.$emit('refresh');
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>
